'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgBookmark(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("path", { d: "M2 2h12v12H2z" }),
            React__default.default.createElement("path", { d: "M11.676 2H4.863C4.113 2 3.5 2.613 3.5 3.363v10.126a.511.511 0 00.712.47l4.057-1.74 4.057 1.74a.511.511 0 00.713-.47V3.363c0-.75-.614-1.363-1.363-1.363zm0 10.22l-3.407-1.485-3.406 1.485V3.363h6.813v8.857z", fill: "currentColor" }))));
}

module.exports = SvgBookmark;
//# sourceMappingURL=Bookmark.js.map
